import { PeriodValue } from "features/common/Interfaces";
import { IProgressEntity } from "./ProgressHelpers";
import { IReportTypeOption } from "features/Reports";
export const monthArNames = [
  "يناير",
  "فبراير",
  "مارس",
  "أبريل",
  "مايو",
  "يونيو",
  "يوليو",
  "أغسطس",
  "سبتمبر",
  "أكتوبر",
  "نوفمبر",
  "ديسمبر",
];
export const monthEnNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
// Common Functions
export const getFirstName = (name: string) => {
  const firstName = name.split(" ");
  if (firstName[0].length <= 3)
    if (firstName.length <= 2) return name;
    else return firstName[0] + " " + firstName[1];
  return firstName[0];
};

export function sortChartData(a: IProgressEntity, b: IProgressEntity) {
  if (a.assignedLos > b.assignedLos) return 1;
  if (a.assignedLos === b.assignedLos && a.avgCompletedLos > b.avgCompletedLos)
    return 1;
  return -1;
}

export function getRangeList(
  initialOptions: IReportTypeOption[],
  academicStartDate: string,
  dir: "rtl" | "ltr"
) {
  let options = [...initialOptions];
  const start = new Date(academicStartDate);
  const end = new Date();
  if (start.getTime() <= end.getTime()) {
    if (start.getDate() > end.getDate()) start.setDate(end.getDate());
    while (start.getTime() <= end.getTime()) {
      const currentMonth = start.getMonth();
      if (end.getMonth() === currentMonth) break;
      const currentOption = {
        label:
          dir === "rtl"
            ? monthArNames[currentMonth]
            : monthEnNames[currentMonth],
        value: monthEnNames[currentMonth].toUpperCase() as PeriodValue,
        type: "month",
      };
      options.push(currentOption);
      start.setMonth(currentMonth + 1);
    }
  }

  return options;
}
